import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const inputProps: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
};

export const paperProps: SxStyle = {
  backgroundColor: 'white',
  backgroundImage: 'none',
  borderColor: (p) => p.palette.primary[500],
};

export const menuListProps: SxStyle = {
  maxHeight: (p) => p.spacing(20),
};
